import React from 'react';
import PropTypes from 'prop-types';
import Colors from 'common/constants/colors';
import './index.scss';

export default class ShadedBackground extends React.Component {
  static propTypes = {
    borderTop: PropTypes.bool,
    children: PropTypes.any,
    style: PropTypes.object,
  };

  static defaultProps = {
    style: {
      backgroundColor: Colors.gray200,
    },
  };

  render() {
    return (
      <div
        className={`ShadedBackground${
          this.props.borderTop ? ' Container--borderTop' : ''
        }`}
        style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}
